module.exports = __webpack_public_path__ + "img/informatica-02.c3ba3d3e.jpg";